import { render } from "./DropdownItem.vue?vue&type=template&id=532004e0"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"

import "./DropdownItem.vue?vue&type=style&index=0&id=532004e0&lang=scss"
script.render = render

export default script